export const frontmatter = {
    "draft": true,
    "title": "Roles",
    "description": "Gestión de roles y permisos en OnnIA.",
    "sidebar_label": "Roles",
    "sidebar_group": "referencia",
    "sidebar_order": 2
}

export const toc = []